import { createSlice } from "@reduxjs/toolkit";
import {
  LOGIN,
  LOGOUT,
  REFRESH,
  REGISTER,
  STORE_ONBOARD,
} from "../Constants/urls";
import { displayToast } from "./ToastSlice";

export const slice = createSlice({
  name: "admin",
  initialState: {
    token: "",
    name: "",
    role: "",
    fetching: false,
  },
  reducers: {
    setAdmin: (state, action) => {
      const { token, name, role } = action.payload;
      state.token = token;
      state.name = name;
      state.role = role;
    },
    deleteAdmin: (state, action) => {
      state.token = "";
      state.name = "";
      state.role = "";
    },
    setFetching: (state, action) => {
      state.fetching = action.payload;
    },
  },
});

export const { setAdmin, deleteAdmin, setFetching } = slice.actions;

export const login = (admin: any) => async (dispatch: any) => {
  dispatch(setFetching(true));

  let res;

  try {
    res = await window.fetch(LOGIN, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(admin),
    });

    const data = await res.json();

    console.log(data);

    if (res.status === 200) {
      dispatch(setAdmin(data));
    } else {
      dispatch(displayToast(data.msg));
    }
  } catch (err) {
    console.log(err);
  }
  dispatch(setFetching(false));
};

export const refresh = () => async (dispatch: any) => {
  dispatch(setFetching(true));
  let res;

  try {
    res = await window.fetch(REFRESH, {
      credentials: "include",
    });

    if (res.status === 200) {
      const data = await res.json();
      console.log("refresh data: ", data);
      dispatch(setAdmin(data));
    } else {
      dispatch(displayToast("Please login in again."));
    }
  } catch (err: any) {
    console.log(err);
    dispatch(displayToast(err));
  }
  dispatch(setFetching(false));
};

export const register = (admin: any) => async (dispatch: any) => {
  dispatch(setFetching(true));

  let res;

  try {
    res = await window.fetch(REGISTER, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(admin),
    });
    const { msg } = await res.json();
    dispatch(displayToast(msg));
  } catch (err: any) {
    console.log(err);
    dispatch(displayToast(err));
  }
  dispatch(setFetching(false));
};

export const logout = () => async (dispatch: any) => {
  dispatch(setFetching(true));

  let res;

  try {
    res = await window.fetch(LOGOUT, {
      method: "POST",
      credentials: "include",
    });
    const { msg } = await res.json();
    dispatch(displayToast(msg));
  } catch (err: any) {
    console.log(err);
    dispatch(displayToast(err));
  }
  dispatch(setFetching(false));
};

export const store_onboard =
  (store: any, cb?: any) => async (dispatch: any) => {
    dispatch(setFetching(true));

    let res;

    try {
      res = await window.fetch(STORE_ONBOARD, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(store),
      });
      if (res.status === 200) {
        const msg = "Store Onboarded Successfully";
        dispatch(displayToast(msg));
        cb && cb();
      } else {
        dispatch(displayToast("Please check entered info again."));
      }
    } catch (err: any) {
      console.log(err);
      dispatch(displayToast(err));
    }
    dispatch(setFetching(false));
  };

export const getToken = (state: any) => state.admin.token || null;

export const getName = (state: any) => state.admin.name;

export const getRole = (state: any) => state.admin.role || null;

export const selectAdminFetching = (state: any) => state.admin.fetching;

export default slice.reducer;
